import React from 'react';
import Select from 'react-select'
import { useTranslation } from 'react-i18next';
import '../../i18n';

const RegionsInput = (props) => {
    const { t } = useTranslation();
    const { regionsValue, handleChangeOnRegions, regionsOption, isDesktop } = props

    return (
        <div className={`w-full md:w-1/3 px-3 mb-6 md:mb-0 ${!isDesktop ? 'self-end' : ''}`}>
            <Select
                value={regionsValue}
                isMulti
                name="regionsValue"
                options={regionsOption}
                className="basic-multi-select"
                placeholder={t('regions')}
                classNamePrefix="select"
                onChange={handleChangeOnRegions}
            />
        </div>
    )
}

export default RegionsInput;